/* global console setTimeout Promise */
import React from "react";
import ReactClass from "create-react-class";
import * as _ from "lodash";

import ScalePropertySelector from "./PropertySelector.Scale.jsx";
import EnumPropertySelector from "./PropertySelector.Enum.jsx";
import EventPropertySelector from "./PropertySelector.Event.jsx";

import PropertyModel from "./PropertyModel";
import DialogService from "../../components/widgets/DialogService";
import AI from "../../appInsights";

const SelectorContainer = ReactClass({
  displayName: "PropertySelector",
  getInitialState() {
    return {
    };
  },
  render() {
    const { prop } = this.props;
    return (
      <section className="property-select-customise">
        <header>
          {prop.group} - {prop.displayName}
        </header>
        <section>{this.props.children}</section>
        <footer>
          <button id="btnCloseDlg" className="inline primary header-action dropdown-dialog-button"
            onClick={this.props.onClose}>Close</button>
          <button id="btnAddAttrDlg" className="inline primary header-action"
            onClick={() => this.props.onAdd(prop)}>Add Attribute(s)</button>
        </footer>
      </section>
    );
  }
});


export default ReactClass({
  displayName: "PropertySelector",
  getInitialState() {
    return {
      panelShowing: false,
      originalPropGroups: [],
      propGroups: [],
      properties: [],
      filterText: "",
      showProperties: undefined,
      loading: false,
    };
  },
  componentWillReceiveProps(nextProps) {
    const { type, mode, showProperties } = nextProps;

    if (type && mode) {
      this.setState({ loading: true });
      PropertyModel.forModel(type, mode).then(propModel => {
        this.setState({ propModel, loading: false });
        if (type && type !== this.state.applianceType) {
          this.resetProperties(type, mode);
        } else if (showProperties && showProperties.length && !this.state.showProperties) {
          this.setState({ showProperties });
          this.resetProperties(type, mode, showProperties);
        }
      }, errResponse => {
        this.setState({ loading: false });
      });
    }

    if (nextProps.fieldSelection) {
      this.setState({ fieldSelection: nextProps.fieldSelection });
      let props = _.cloneDeep(this.state.properties);
      
      // // NEW: Reset auto-selection states first
      // props.forEach(prop => {
      //   prop.autoSelected = false;
      //   prop.requiredBy = [];
      //   prop.canDeselect = true;
      // });
      
      // PRESERVE: Original selection marking logic
      nextProps.fieldSelection.forEach(prop => {
        const index = _.findIndex(props, { id: prop.id });
        if (index !== -1) {
          props = [
            ...props.slice(0, index),
            Object.assign({}, props[index], { 
              selected: true,  // PRESERVE: Always mark as selected for parent
              autoSelected: prop.autoSelected,  // NEW: Track auto-selection
              manuallySelected: prop.manuallySelected  // NEW: Track manual selection
            }),
            ...props.slice(index + 1)
          ];
        }
      });
      
      this.setState({ properties: props });
    }
  },

  resetProperties(type, mode, showProperties = undefined) {
    const selections = this.state.fieldSelection;
    this.setState({ loading: true });
    PropertyModel.forModel(type, mode).then(propModel => {
      this.setState({ loading: false });
      if (!propModel) {
        return;
      }

      this.propertyModel = new PropertyModel(propModel);
      if (showProperties && showProperties.length) {
        this.propertyModel.keep(showProperties);
      }

      const propGroups = this.propertyModel.byTypeGrouped("Temp", "RPM", "Numeric", "Number", "Bool", "Enum", "EnumLine", "MixedEnumNumber");

      this.setState({
        properties: _.clone(this.propertyModel.getAll()).map(p => {
          p.selected = !!_.find(selections, { id: p.id });
          p.autoSelected = false;           // NEW: Track auto-selected state
          p.requiredBy = [];               // NEW: Track which props require this
          p.canDeselect = true;            // NEW: Track if can be manually deselected
          p.manuallySelected = p.selected; // NEW: Track manual vs auto selection
          return p;
        }),
        originalPropGroups: propGroups,
        propGroups,
        applianceType: type
      });
    }, errResponse => {
      this.setState({ loading: false });
    });
  },

  addProperty(propId, selected, config = {}) {
    const props = this.state.properties,
      index = _.findIndex(props, { id: propId });
    if (index !== -1) {
      this.setState({
        properties: [
          ...props.slice(0, index),
          Object.assign({}, props[index], { selected }, config),
          ...props.slice(index + 1)
        ]
      });
      return true;
    }
  },

  toggleProperty(prop, selected, config = {}) {
    const propId = prop.id;
    prop = this.state.properties.find(p => p.id === propId);
    if (!prop) return false;
    
    // NEW: Handle deselection restrictions for auto-selected dependencies
    if (!selected && prop.autoSelected && prop.requiredBy?.length > 0) {
      this.showLockWarning(prop);
      return false; // Block deselection of required dependencies
    }
    
    // NEW: Handle dependent field logic BEFORE original logic
    if (selected && prop.dependentField) {
      this.updateDependentSelection(prop, true);
    } else if (!selected && prop.dependentField) {
      this.updateDependentSelection(prop, false);
    }
    
    // PRESERVE: Original logic unchanged
    if (this.addProperty(propId, selected, config)) {
      setTimeout(() => {
        this.trackAddedProperties();
        this.trigger();
      }, 100);
      return true;
    }
    return false;
  },

  addProperties(selection) {
    const relatedSelIds = _.keys(selection.relatedSelections).map(Number),
      mainSelId = selection.prop.id,
      toAdd = [mainSelId, ...relatedSelIds];

    let props = _.cloneDeep(this.state.properties);
    toAdd.forEach(propId => {
      const index = _.findIndex(props, { id: propId });
      if (index !== -1) {
        let self = props[index],
          cfg = (selection.panelIdx) ? { panelIdx: selection.panelIdx } : {};

        if (selection.plotLocationSelection) {
          cfg.targetLine = Number(selection.plotLocationSelection);
        } else if (_.includes(relatedSelIds, propId) &&
          selection.relatedSelections[propId].mode === "this-line") {
          cfg.targetLine = mainSelId;
        } else if (_.includes(relatedSelIds, propId) &&
          selection.relatedSelections[propId].mode === "x-axis") {
          cfg.targetLine = "x-axis";
        } else if (_.includes(relatedSelIds, propId) &&
          selection.relatedSelections[propId].mode === "set-point") {
          cfg.against = mainSelId;
        }

        props = [
          ...props.slice(0, index),
          Object.assign({}, self, { selected: true }, cfg),
          ...props.slice(index + 1)
        ];
      }
    });

    this.setState({
      properties: props
    });
    setTimeout(() => {
      this.trackAddedProperties();
      this.trigger();
    }, 100);
  },

  trackAddedProperties() {
    const selected = _.filter(this.state.properties, { selected: true }),
      trackSelected = selected.map(data =>
        JSON.stringify(_.pick(data, "displayName", "group", "name", "type"))
      );
    AI.trackEvent("GraphDataFilter", {
      "Appliance Type": this.state.applianceType, "selectedData": trackSelected.join("/")
    }, { "selectedDataCount": trackSelected.length });
  },

  trigger() {
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(_.filter(this.state.properties, { selected: true }));
    }
  },

  clearAll() {
    const props = this.state.properties;
    this.setState({
      activeProperty: null,
      properties: props.map(p => Object.assign({}, p, { 
        selected: false,
        autoSelected: false,    // NEW: Clear auto-selection
        requiredBy: [],         // NEW: Clear dependencies
        canDeselect: true,      // NEW: Reset deselection ability
        manuallySelected: false // NEW: Clear manual selection tracking
      }))
    });
    setTimeout(() => {
      const selected = _.filter(this.state.properties, { selected: true });
      this.props.onSelectionChange && this.props.onSelectionChange(selected);
    }, 100);
  },

  togglePanel() {
    const newState = !this.state.panelShowing;
    if (newState) {
      AI.trackEvent("GraphDataFilterPanel", { "Appliance Type": this.state.applianceType });
    }
    this.setState({ activeProperty: null, panelShowing: newState });

    if (newState === true) {
      DialogService.makeDialog(this.panel, this.button, () => {
        this.setState({ panelShowing: false, activeProperty: false });
      });
    }
  },

  filterProps(filterStr) {
    const origProps = this.state.originalPropGroups,
      filtered = () => {
        return _.cloneDeep(origProps).map(group => {
          group.properties = group.properties.filter(prop =>
            prop.displayName.toLowerCase().indexOf(filterStr.toLowerCase()) !== -1
          );
          return group;
        });
      }
      ;
    this.setState({
      filterText: filterStr,
      propGroups: filterStr.trim().length > 1 ?
        filtered().filter(g => g.properties.length > 0) :
        origProps
    });
  },

  expand(activeProperty) {
    this.setState({ activeProperty });
  },

  renderFlatList(list) {
    const activeProp = this.state.activeProperty || {};
    return list.length > 0
      ? list.map((prop, index) => {
      // PRESERVE: Original data structure
      const checked = prop.id && _.find(this.state.properties, { id: prop.id }).selected,
        preFetch = !!prop.preFetch,
        active = prop.id === activeProp.id,
        hasMore = _.includes(["Enum", "Bool"], prop.type) ||
          (prop.relatedAttributes && prop.relatedAttributes.length);

      // NEW: Additional data for enhancements  
      const propData = _.find(this.state.properties, { id: prop.id }) || prop;
      // Ensure arrays exist
      if (!propData.requiredBy) propData.requiredBy = [];
      
      const isAutoSelected = propData.autoSelected || false,
        canDeselect = this.canDeselectProperty(propData);

      // PRESERVE: Original CSS classes + ADD new ones
      const originalItemCls = [(checked ? "selected" : ""), (active ? "active" : "")].join(" ");
      const enhancedItemCls = [
        originalItemCls,
        isAutoSelected ? "auto-selected" : "",
        !canDeselect && checked ? "locked" : ""
      ].filter(Boolean).join(" ");

      // PRESERVE: Original tooltip + ADD enhancements
      const originalTooltip = prop.displayName + 
        (prop.description ? '\r\n' + prop.description + '\n' : '') + 
        (prop.valuesDescription ? '\r\n' + prop.valuesDescription : '');
      const enhancedTooltip = this.getTooltipText({ ...prop, ...propData }) || originalTooltip;

      // SAFE: Enhanced onClick that preserves all original behavior
      const handleClick = () => {

        if (!checked) {
          // Always allow selection
          this.toggleProperty(prop, true);
        } else if (prop.canDeselect) {
          // Allow deselection if permitted
          this.toggleProperty(prop, false);
                  } else {
            // Show warning but don't break the flow
            this.showLockWarning(propData);
          }
      };

      return prop.heading ?
        // PRESERVE: Original heading rendering
        (<li key={"h_" + index} className="heading"><strong>{prop.heading || "<Unknown>"}</strong></li>) :
        // ENHANCED: Property rendering with backward compatibility
        (<li key={"p_" + index} className={enhancedItemCls}>
          <i className={`icon-check ${checked ? "checked" : "unchecked"} ${isAutoSelected ? "auto" : ""}`}
            onClick={handleClick} />
          <span title={enhancedTooltip} 
                className={`property-name ${preFetch ? "prefetched" : ""}`}
                onClick={handleClick}>
            {/* NEW: Visual indicators with simple text/unicode */}
            {isAutoSelected && <span className="auto-icon">🔗</span>}
            <span className="display-name">{prop.displayName}</span>
            {isAutoSelected && <em className="status-indicator">(auto)</em>}
          </span>
          {/* PRESERVE: Original more options logic */}
          {active ?
            (<label><i className="icon-chevron-right" /></label>) :
            (hasMore ? <label onClick={() => this.expand(prop)}>...</label> : null)
          }
        </li>)
        ;
    })
    : (<div className="empty">{`No graph configuration available for this device.`}</div>);
  },

  renderSelector(prop, propModel) {
    const close = () => this.setState({ activeProperty: false }),
      add = () => {
        this.addProperties(
          Object.assign({ prop }, this.activePropertySelector.getSelections())
        );
        this.togglePanel();
      },
      existingSeries = this.state.fieldSelection;
    switch (prop.type) {
      case "Enum":
      case "Bool":
        return (
          <SelectorContainer prop={prop} onClose={close} onAdd={add}>
            <EnumPropertySelector prop={prop} model={propModel} series={existingSeries}
              ref={x => this.activePropertySelector = x} />
          </SelectorContainer>
        );
      case "Temp":
      case "RPM":
      case "EnumLine":
        return (
          <SelectorContainer prop={prop} onClose={close} onAdd={add}>
            <ScalePropertySelector prop={prop} model={propModel} series={existingSeries}
              ref={x => this.activePropertySelector = x} />
          </SelectorContainer>
        );
      // case "Event":
      //   return (
      // <SelectorContainer prop={prop} close={close}>
      // <EventPropertySelector prop={prop} model={propModel} series={existingSeries} />
      // </SelectorContainer>
      // );
      default:
        return undefined;
    }
  },

  // NEW: Helper methods for dependent field functionality
  findDependentProperty(prop) {
    if (!prop.dependentField) return null;
    const groupsList = this.state.propGroups
    .map(entry => ([
      { heading: entry.group },
      ...entry.properties
    ])),
    flatList = _.flatten(groupsList)
    return flatList.find(p => 
      p.name === prop.dependentField || 
      p.valueField === prop.dependentField
    );
  },

  updateDependentSelection(mainProp, isSelecting) {

    if (!mainProp.dependentField) return;
    
    const dependentProp = this.findDependentProperty(mainProp);
    if (!dependentProp) {
        console.warn(`Dependent property ${mainProp.dependentField} not found for ${mainProp.displayName}`);
        return;
    }    
    
    let needsUpdate = false;
    
    if (isSelecting) {
      // Add this property to dependent's requiredBy list
      if (!dependentProp.requiredBy.includes(mainProp.id)) {
        dependentProp.requiredBy.push(mainProp.id);
      }
      // Auto-select the dependent property if not already selected
      if (!dependentProp.selected && !dependentProp.autoSelected) {
        dependentProp.autoSelected = true;
        dependentProp.selected = true;
        needsUpdate = true;
        console.log(`Auto-selecting dependent property: ${dependentProp.displayName}`);
      }
      // Update canDeselect status - false when required by others, true when not required
      dependentProp.canDeselect = dependentProp.requiredBy.length === 0;
      
    } else {
      // Remove this property from dependent's requiredBy list
      dependentProp.requiredBy = dependentProp.requiredBy.filter(id => id !== mainProp.id);
      
      // If no longer required by anyone, allow deselection and remove auto-selection status
      if (dependentProp.requiredBy.length === 0) {
        dependentProp.canDeselect = true;
        // Remove auto-selected flag - now user can manually decide whether to keep it
        if (dependentProp.autoSelected) {
          dependentProp.autoSelected = false;
          dependentProp.selected = false;
          needsUpdate = true;
          console.log(`Auto-deselecting dependent property: ${dependentProp.displayName}`);
        }
      } else {
        dependentProp.canDeselect = false;
      }
    }
    
    //Sync with this.state.properties
    const propObject = this.state.properties.find(p => p.id === dependentProp.id);
    if (propObject) {
      propObject.autoSelected = dependentProp.autoSelected;
      propObject.requiredBy = dependentProp.requiredBy;
      propObject.canDeselect = dependentProp.canDeselect;
      propObject.selected = dependentProp.selected;
    } 
    
    this.setState({ propGroups: [...this.state.propGroups], properties: [...this.state.properties] });
    
    // Trigger parent update if dependent selection changed
    if (needsUpdate) {
      setTimeout(() => {
        this.trigger();
      }, 10);
    }
  },

  canDeselectProperty(prop) {
    // Can deselect if:
    // 1. Not explicitly marked as non-deselectable
    // 2. Either not auto-selected, OR not required by anyone
    return prop.canDeselect !== false && 
           (!prop.autoSelected || (prop.requiredBy && prop.requiredBy.length === 0));
  },

  getTooltipText(prop) {
    // PRESERVE: Original tooltip format first
    let tooltip = prop.displayName;
    if (prop.description) {
      tooltip += `\r\n${prop.description}\n`;
    }
    if (prop.valuesDescription) {
      tooltip += `\r\n${prop.valuesDescription}`;
    }
    
    // ADD: New dependency information
    if (prop.autoSelected && prop.requiredBy?.length > 0) {
      const requiredByNames = prop.requiredBy.map(id => {
        const requiringProp = this.state.properties.find(p => p.id === id);
        return requiringProp?.displayName || 'Unknown';
      }).join(', ');
      tooltip += `\r\n\r\n🔗 Auto-selected - Required by: ${requiredByNames}`;
      tooltip += `\r\nCannot be removed while required.`;
    } else if (!prop.autoSelected && prop.selected && prop.requiredBy?.length === 0) {
      // Property was auto-selected but is now free to be manually deselected
      tooltip += `\r\n\r\n✓ Optional - Can be manually removed if not needed.`;
    }
    
    if (prop.dependentField) {
      const dependentProp = this.findDependentProperty(prop);
      const dependentName = dependentProp?.displayName || prop.dependentField;
      tooltip += `\r\n\r\n➡️ Selecting this will also select: ${dependentName}`;
    }
    
    return tooltip;
  },

  showLockWarning(prop) {
    const requiredByNames = prop.requiredBy.map(id => {
      const requiringProp = this.state.properties.find(p => p.id === id);
      return requiringProp?.displayName || 'Unknown';
    }).join(', ');
    
    alert(`Cannot remove "${prop.displayName}" - it is required by: ${requiredByNames}`);
  },

  render: function () {
    const {state: {fieldSelection, activeProperty: activeProp, properties: props, loading}} = this,
      groupsList = this.state.propGroups
        .map(entry => ([
          { heading: entry.group },
          ...entry.properties
        ])),
      flatList = _.flatten(groupsList),
      panelHeight = 380,
      entryDim = { height: 25, width: 250 },
      entriesPerColumn = Math.floor(panelHeight / entryDim.height),
      columnCount = Math.ceil(flatList.length / entriesPerColumn),
      panelWidth = columnCount * entryDim.width + (columnCount * 10),
      selectedIdx = activeProp ? _.findIndex(flatList, { id: activeProp.id }) : 0,
      lastHeadingIdx = _.findLastIndex(flatList, e => !!e.heading, selectedIdx),
      displayList = _.slice(flatList, lastHeadingIdx),
      { activeProperty, filterText } = this.state;

    return (
      <div className="dropdown-dialog-container">
        {/* {props && (<button className="inline primary header-action dropdown-dialog-button"
                           ref={x => this.button = x}
                           disabled={this.props.disabled || false}
                           onClick={this.togglePanel}>
          Data Filters&#160;<i className="icon-chevron-down" />
        </button>)} */}
        <section ref={x => this.panel = x}
          // style={{width: (Math.max(panelWidth, 530)) + "px"}}
          className={"dropdown-dialog property-selector-panel in"}>
          {this.props.header}
          <header>
            <i className="icon-search" />
            <input id="inputSearch" type="text" placeholder="Quick Search..."
              disabled={activeProperty}
              value={filterText}
              onChange={e => this.filterProps(e.target.value)}
            />
            <i id="iClearInput" className="icon-x clear-input" onClick={() => this.filterProps("")} />
            <a id="aClearAll" onClick={this.clearAll}>Clear All</a>
            {/* <a id="aClose" onClick={this.togglePanel}>Close</a> */}
          </header>
          {
            <div id="divNotice" className={fieldSelection && fieldSelection.length>1?'notice visible':'notice hidden'}>Notice: Multiple Selections May Impact Load Performance</div>
          }
          <div className="property-list">
            <ul className="property-group">
              {loading
              ? (<div className="loading">
                  <i className={"anim icon icon-loader spin"}></i>
                </div>)
              : this.renderFlatList(displayList)}
            </ul>
            {activeProperty && this.renderSelector(activeProperty, this.propertyModel)}
          </div>
          {this.props.footer}
        </section>
      </div>
    );
  }
});
